var MantleQuiz = MantleQuiz || {};
var MantleForm = MantleForm || {};
var JSBoot = JSBoot || {};
var prodcat = prodcat || {};
var generic = generic || {};
var MantleFormPage = (function (MantleFormPage, $) {
  var MantleFormPageManager = function (quiz_info, quiz_form, $formatter) {
    this.quiz_info = quiz_info;
    this.quiz_form = quiz_form;
    this.$formatter = $formatter;
    this.form_name = $formatter.data('form-name');

    window.onpopstate = function (event) {
      // Only process system browser events. Ignore triggered elements.
      // For now the asumption is that any non jquery triggered event is
      // real.
      if (!!event.isTrigger) {
        return;
      }
      if (JSBoot.URL.getParam('_step')) {
        $formatter.trigger('refresh-from-url-state', [false]);

        return;
      }
    };

    var init_state = $formatter.data('init-state');

    if (!init_state) {
      init_state = 'bare_form';
    }

    if (JSBoot.URL.getParam('init_state')) {
      init_state = JSBoot.URL.getParam('init_state');
    }

    this.init_state = init_state;

    // Prime the subject data.
    MantleQuiz.quiz_info_state.getSubject(this.form_name, quiz_info);
    MantleQuiz.quiz_form_state.getSubject(this.form_name, quiz_form);
  };

  /*
   * We need our own custom move-to-after handler because our form steps don't
   * have submit buttons. They auto move on selection.
   */
  MantleFormPageManager.prototype.attach_move_on_handler = function () {
    var self = this;
    var $form = this.get_form();

    $form.on('mantle-form:move-to-after', function (e, field_name) {
      self.handle_move_after(e, field_name);
    });
    // Need to supercede the mantle event handler.
    var move_after_handlers = $._data($form.get(0), 'events')['mantle-form:move-to-after'];
    var our_handler = move_after_handlers.pop();

    move_after_handlers.splice(0, 0, our_handler);
  };

  /*
   * Main logic handling how the page renders based on query args.
   */
  MantleFormPageManager.prototype.handle_init = function () {
    var quiz_info = this.quiz_info;
    var $formatter = this.$formatter;
    var form_name = this.form_name;
    var self = this;
    var show_results = false;

    if (JSBoot.URL.getParam('show_results')) {
      show_results = true;
    }

    // var form_data = MantleForm.get_form_data_from_form_state_form_manager(form_name);
    var query_answers = MantleForm.get_form_answers_from_query_string(quiz_info);
    var query_answers_valid = MantleForm.validate_form_answers_data(query_answers, quiz_info);

    if (query_answers_valid && show_results) {
      // don't trigger a push state
      $formatter.data('refreshing-from-url', 1);
      self.show_form();
      self.render_form(true);
      $formatter.trigger('mantle-form:request-form-results', [query_answers, true]);
      $formatter.data('refreshing-from-url', 0);

      return;
    }

    if (JSBoot.URL.getParam('_step')) {
      $formatter.trigger('refresh-from-url-state', [true]);

      return;
    }

    // The stuff below requires we have the user quiz state
    MantleQuiz.get_quiz_data(form_name).then(function (quiz_data) {
      // not answered. show quiz
      if (!quiz_data || !quiz_data.answered) {
        self.show_form();
        self.render_form();

        return;
      }

      var form_answers = quiz_data.answers;
      var form_answers_valid = MantleForm.validate_form_answers_data(form_answers, quiz_info);

      self.show_form();
      self.render_form();

      /*
       * Brand decided to not show results if you have them
            if (form_answers_valid) {
              $formatter.trigger('mantle-form:request-form-results', [form_answers, true]);
            }
            */
      return;
    });
  };

  MantleFormPageManager.prototype.attachSpinner = function () {
    // TODO need to add platform changes so I dont need to do this via JS
    // here.
    // NOTE: we're doing this for the gif image.
    var $formatter = this.$formatter;
    var $loadingImage = $('.quiz-landing-page-formatter__loading__bg-image', $formatter);
    var $ajaxSpinners = $('.mantle-ajax-form-options-field__spinner', $formatter);

    if (!$loadingImage.length) {
      return;
    }
    $ajaxSpinners.each(function (i, obj) {
      var $ajaxSpinner = $(obj);

      $ajaxSpinner.html($loadingImage.clone());
    });
  };

  /*
   * The base behavior of forms is that they move to next field if there is no
   * CTA button. Since 2F has no CTA buttons, we need to account for the
   * refreshing from url since we don't want to auto select the next field when
   * loading from url.
   */
  MantleFormPageManager.prototype.handle_move_after = function (e) {
    if (this.$formatter.data('refreshing-from-url') === 1) {
      e.preventDefault();
      e.stopPropogation();

      return;
    }
  };

  /*
   * Get the form manager via getter. The Form itself isn't always rendered so
   * this is lazy.
   */
  MantleFormPageManager.prototype.get_form_manager = function () {
    var $form = this.get_form();
    var form_manager = $form.data('form-manager');

    return form_manager;
  };

  MantleFormPageManager.prototype.get_form = function () {
    var $formatter = this.$formatter;
    var $form = $('.js-form-formatter', $formatter).first();

    return $form;
  };

  /*
   * Render the form
   */
  MantleFormPageManager.prototype.render_form = function (disable_form_active) {
    var $formatter = this.$formatter;
    var quiz_form = this.quiz_form;
    var $formContainer = $('.js-quiz-landing-page-quiz-form', $formatter);

    if (!!disable_form_active) {
      $formatter.attr('data-disable-default-form-set-active', 1);
    }
    var $form = $('.js-form-formatter', $formatter);

    if ($form.length === 0) {
      $formContainer.html(quiz_form.html);
      this.attachSpinner();

      Drupal.attachBehaviors($formContainer);
    }
    if (!!disable_form_active) {
      $formatter.attr('data-disable-default-form-set-active', 0);
    }

    // This needs $form to exist first.
    this.attach_move_on_handler();
  };

  /*
   * Show the form
   */
  MantleFormPageManager.prototype.show_form = function () {
    var $formatter = this.$formatter;

    $formatter.addClass('show-quiz');
    $formatter.removeClass('show-results');
  };

  MantleFormPageManager.prototype.refresh_from_url = function () {
    var $formatter = this.$formatter;
    var quiz_info = this.quiz_info;

    $formatter.data('refreshing-from-url', 1);
    var query_answers = MantleForm.get_form_answers_from_query_string(quiz_info);
    var current_step = JSBoot.URL.getParam('_step');

    // disable forms default
    this.show_form();
    this.render_form(true);
    var $form = $('.js-form-formatter', $formatter).first();
    var form_manager = this.get_form_manager();

    form_manager.save_answers_to_form_state(query_answers, false);
    form_manager.apply_answers_from_form_state(true);
    $form.trigger('form-set-active', [current_step]);
    $formatter.data('refreshing-from-url', 0);
  };

  MantleFormPageManager.prototype.url_push_state = function (query_string) {
    var stateObj = {};
    var new_url = window.location.pathname;

    if (!_.isEmpty(query_string)) {
      new_url = new_url + '?' + query_string;
    }

    history.pushState(stateObj, '', new_url);
  };

  // function to pop Loading Results modal
  //
  MantleFormPageManager.prototype.pop_loading = function ($loading) {
    $('body').addClass('quiz-loading-results');
    var options = {
      content: $loading,
      className: 'colorbox--quiz--loading',
      width: '100%',
      height: '100%',
      fixed: true,
      opacity: 1
    };

    options['overlayClose'] = false;
    options['closeButton'] = false;

    options['onComplete'] = function () {
      $('html,body').addClass('no-scroll');
      $('html,body').addClass('overlay-active');
      $('html,body').addClass('quiz-loaded');

      $.colorbox.resize();
    };

    options['onCleanup'] = function () {
      $('html,body').removeClass('no-scroll');
      $('html,body').removeClass('overlay-active');
    };

    generic.overlay.launch(options);
  };

  MantleFormPage.MantleFormPageManager = MantleFormPageManager;

  return MantleFormPage;
})(MantleFormPage || {}, jQuery);

(function ($) {
  $(document).on('quiz-scroll-to', function (e, top) {
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  });

  Drupal.behaviors.quizLandingPageFormatterV1 = {
    attach: function (context, settings) {
      var $formatters = $('.js-quiz-landing-page-formatter', context);
      var formAnswer;

      // disable autoscroll in chrome
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
      $(window).on('unload', function () {
        $(window).scrollTop(0);
      });

      var that = this;

      $formatters.each(function (i, obj) {
        var $formatter = $(obj);
        var $resultContainer = $('.js-quiz-landing-page-formatter__results', $formatter);
        var $loading = $('.js-quiz-landing-page-formatter__loading', $formatter);
        var $formContainer = $('.js-quiz-landing-page-quiz-form', $formatter);
        var form_name = $formatter.data('form-name');
        var quiz_info = window.__quiz_info__[form_name];
        var quiz_form = window.__quiz_form__[form_name];
        var $form = $('.js-form-formatter', $formatter).first();
        var page_manager = new MantleFormPage.MantleFormPageManager(
          quiz_info,
          quiz_form,
          $formatter
        );

        /*
         * Form was submitted.
         */
        $formatter.on('mantle-form:submit-requested', function (e) {
          page_manager.pop_loading($loading);

          var form_manager = page_manager.get_form_manager();
          var form_answers = form_manager.gather_answers();

          formAnswer = form_answers;
          // PG backed forms need to make a remote call.
          var save_promise = form_manager.save_answers(form_answers);
          var query_string = MantleForm.from_answers_to_query_string(form_answers, quiz_info);

          query_string = 'show_results=1&' + query_string;
          $formatter.trigger('form-set-pushstate', [query_string]);

          save_promise.then(function () {
            $formatter.trigger('mantle-form:request-form-results', [form_answers, false]);
          });
        });

        $formatter.on('mantle-form:request-form-results', function (e, form_answers, show_loading) {
          if (!!show_loading) {
            page_manager.pop_loading($loading);
          }
          var result_promise = MantleQuiz.rpc.get_quiz_results(form_name, form_answers);

          result_promise.then(function (result_html) {
            $formatter.trigger('mantle-quiz-render-results', [result_html]);
          });
        });

        $formatter.on('form-set-active-done', function (e, field_name, form_answers) {
          $formatter.trigger('mantle-form:scroll-to-top');
          $formatter.trigger('mantle-form:copy-button');
          window.setTimeout(function () {
            $formatter.trigger('mantle-form:reset-ios-scroll');
          }, 100);

          if ($formatter.data('refreshing-from-url') === 1) {
            return;
          }

          var _query_string = MantleForm.from_answers_to_query_string(form_answers, quiz_info);
          var query_string = '';

          if (field_name !== 'intro') {
            query_string = '_step=' + field_name;
          }
          if (_query_string) {
            query_string = query_string + '&' + _query_string;
          }
          $formatter.trigger('form-set-pushstate', [query_string]);
        });

        /*
         * Handle setting push state
         */
        $formatter.on('form-set-pushstate', function (e, query_string) {
          page_manager.url_push_state(query_string);
        });

        $formatter.on('refresh-from-url-state', function (e, init_form) {
          page_manager.refresh_from_url(init_form);
        });

        $formatter.on('click', '.js-mantle-form-reset', function (e) {
          e.preventDefault();
          var $forms = $('.js-form-formatter', $formatter);

          $forms.trigger('form-reset');
          $formatter.removeClass('show-results');
          $formatter.addClass('show-quiz');
        });

        $formatter.on('mantle-quiz-render-results', function (e, render_pack) {
          $resultContainer.html(render_pack.html);

          var loaded_func = function () {
            Drupal.attachBehaviors($resultContainer);
            window.setTimeout(function () {
              prodcat.data.getNewProducts($resultContainer);
              // we wait a bit to give time to load assets
              $formatter.trigger('mantle-quiz-reveal-results');
            }, 500);
          };

          MantleQuiz.render_pack_to(render_pack, {
            target: $resultContainer,
            loaded_func: loaded_func
          });
        });

        // Implements mantle-quiz-submit-requested
        $formatter.on('mantle-quiz-reveal-results', function (e) {
          $('body').removeClass('quiz-loading-results');
          $.colorbox.close();
          $formatter.addClass('show-results');
          $formatter.removeClass('show-quiz');
          $(document).trigger('filterResult', formAnswer);
        });

        /*
         * For the last page, selecting the model image will pop results
         */
        $formatter.on(
          'selectedSlideClickedAfterMove',
          '.js-mantle-form-options-field',
          function () {
            var $optionsField = $(this);
            var $submit = $('.js-mantle-cta-button[data-trigger-type=submit]', $optionsField);

            if ($submit.length) {
              $submit.trigger('click');
            }
          }
        );

        // Run page manager after other attaches
        $(function () {
          page_manager.handle_init();
        });
      });
    }
  };
})(jQuery);
